// src/components/Admin/AdminTransactions.js
"use client";

import { useEffect, useState } from "react";
import { Table, Button, Spinner, Form, Card, Row, Col, Modal, Alert, } from "react-bootstrap";
import api from "../../services/api";
import { toast } from "react-toastify";
import { formatJalali } from "../../utils/date";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import dayjs from "dayjs";
import jalaliday from "jalaliday";
import { SortAlphaUp, SortAlphaDown, Justify, ArrowDownUp } from "react-bootstrap-icons";
import PaginationBarComp from "../Pagination/PaginationBar";
import RefundModal from "../Common/RefundModal";
import { ArrowCounterclockwise } from "react-bootstrap-icons";

dayjs.extend(jalaliday);
dayjs.locale("fa");
dayjs.calendar("jalali");

const AdminTransactionsComp = () => {
	const [page, setPage] = useState(1);
	const [perPage, setPerPage] = useState(10);
	const [totalPages, setTotalPages] = useState(1);

	const [transactions, setTransactions] = useState([]);
	const [loading, setLoading] = useState(true);

	const [isResetting, setIsResetting] = useState(false);

	const [deleteDebtModal, setDeleteDebtModal] =
		useState({
			show: false,
			type: "",
			title: "",
			description: "",
		});

	const [deletingDebt, setDeletingDebt] =
		useState(false);

	const [filter, setFilter] = useState({
		user: "",
		store: "",
		type: "",
		source: "",
		createdBy: "",
		startDate: null,
		endDate: null,
		search: "",
		sortBy: "createdAt",
		sortOrder: "DESC",
	});

	const [refundPurchase, setRefundPurchase] = useState(null);



	const openDebtDeleteConfirmation = (
		type
	) => {
		const config = {
			current: {
			title: "حذف بدهی جاری",
			description:
				"تمام بدهی جاری کاربران به صورت فیزیکی حذف خواهد شد. این عملیات قابل بازگشت نیست.",
			},

			previous: {
			title: "حذف بدهی سال قبل",
			description:
				"تمام بدهی‌های سال قبل کاربران به صورت فیزیکی حذف خواهد شد. این عملیات قابل بازگشت نیست.",
			},

			monthly: {
			title: "حذف کسر ماهانه",
			description:
				"تمام کسرهای ماهانه به صورت فیزیکی حذف خواهند شد. این عملیات قابل بازگشت نیست.",
			},
	};

	const selected = config[type];
		setDeleteDebtModal({
			show: true,
			type,
			title: selected.title,
			description: selected.description,
		});
	};

	const confirmDeleteDebt = async () => {
		if (!deleteDebtModal.type) {
			return;
		}

		setDeletingDebt(true);

		try {
			const endpointMap = {
				current:
					"/admin/transactions/debt/current",

				previous:
					"/admin/transactions/debt/previous",

				monthly:
					"/admin/transactions/debt/monthly",
			};

			const endpoint =
				endpointMap[
					deleteDebtModal.type
				];

			await api.delete(endpoint);

			toast.success(
				`${deleteDebtModal.title} با موفقیت انجام شد.`
			);

			setDeleteDebtModal({
				show: false,
				type: "",
				title: "",
				description: "",
			});

			// Refresh لیست تراکنش‌ها
			await fetchTransactions();
		} catch (err) {
			console.error(err);

			const message =
			err?.response?.data?.message ||
			"خطا در حذف اطلاعات.";

			toast.error(
			Array.isArray(message)
				? message.join("، ")
				: message
			);
		} finally {
			setDeletingDebt(false);
		}
	};



	const fetchTransactions = async () => {
		setLoading(true);
		try {
			const params = {
				...filter,
				page,
				perPage,
				startDate: filter.startDate ? dayjs(filter.startDate).calendar("gregory").format("YYYY-MM-DD") : undefined,
				endDate: filter.endDate ? dayjs(filter.endDate).calendar("gregory").format("YYYY-MM-DD") : undefined,
			};

			const { data } = await api.get("/admin/transactions", { params });

			setTransactions(data.items || []);
			setTotalPages(data.totalPages || 1);
		} catch (err) {
			toast.error("خطا در دریافت تراکنش‌ها");
		} finally {
			setLoading(false);
		}
	};

	// خروجی اکسل
	const [downloading, setDownloading] = useState(false);
	const exportExcel = async () => {
		try {
			setDownloading(true);

			const params = {
				...filter,
				startDate: filter.startDate ? dayjs(filter.startDate).calendar("gregory").format("YYYY-MM-DD") : undefined,
				endDate: filter.endDate ? dayjs(filter.endDate).calendar("gregory").format("YYYY-MM-DD") : undefined,
			};

			const res = await api.get("/admin/transactions/export", {
				params,
				responseType: "blob",
			});

			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "transactions.xlsx");
			document.body.appendChild(link);
			link.click();
		} catch (err) {
			console.error(err);
		} finally {
			setDownloading(false);
		}
	};

	// انتخاب بازه زمانی
	const setRange = (type) => {
		const now = dayjs();
		let start, end;
		if (type === "week") {
			start = now.startOf("week");
			end = now.endOf("week");
		} else if (type === "month") {
			start = now.startOf("month");
			end = now.endOf("month");
		} else if (type === "year") {
			start = now.startOf("year");
			end = now.endOf("year");
		}
		setFilter({
			...filter,
			startDate: start.toDate(),
			endDate: end.toDate(),
		});
    setPage(1);
	};

  // 🔹 مرتب‌سازی با کلیک روی عنوان ستون
  const handleSort = (column) => {
    if (filter.sortBy === column) {
      // اگر روی همون ستون دوباره کلیک شد، جهت رو برعکس کن
      setFilter({
        ...filter,
        sortOrder: filter.sortOrder === "ASC" ? "DESC" : "ASC",
      });
      setPage(1);
    } else {
      // مرتب‌سازی جدید
      setFilter({
        ...filter,
        sortBy: column,
        sortOrder: "ASC",
      });
      setPage(1);
    }
  };

  // 🔹 آیکن جهت مرتب‌سازی
  const SortIcon = ({ column }) => {
    if (filter.sortBy !== column) return <ArrowDownUp size={14} className="ms-1" />;
    return filter.sortOrder === "ASC" ? (
      <SortAlphaDown size={14} className="ms-1" />
    ) : (
      <SortAlphaUp size={14} className="ms-1" />
    );
  };

	const handleReset = () => {
		setFilter({
			user: "",
			store: "",
			type: "",
			source: "",
			createdBy: "",
			startDate: null,
			endDate: null,
			search: "",
			sortBy: "createdAt",
			sortOrder: "DESC",
		});
		setPage(1);
		setIsResetting(true);
	};

  useEffect(() => {
    if (isResetting) {
      fetchTransactions();
      setIsResetting(false);
    }
  }, [isResetting])

	// اعمال فیلتر با کلید Enter
	useEffect(() => {
		const handleKeyDown = (e) => {
			if (e.key === "Enter") {
				fetchTransactions();
			}

      // 🔹 اگر کلید Delete زده شد → فیلترها ریست شوند
      if (e.key === "Delete") {
        e.preventDefault();
        handleReset();
      }
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [filter]);

	useEffect(() => {
    fetchTransactions();
  }, [
    page,
    perPage,
    filter.type,
    filter.source,
    filter.startDate,
    filter.endDate,
    filter.sortBy,
    filter.sortOrder,
  ]);

	if (loading) return <Spinner animation="border" className="d-block m-auto mt-5" />;

	return (
		<>
			<Card className="mb-4 border-danger">
				<Card.Body>
					<div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
					<div>
						<Card.Title className="mb-1 text-danger">
						مدیریت بدهی‌ها
						</Card.Title>

						<div className="text-muted small">
						عملیات زیر حذف فیزیکی انجام می‌دهند و
						قابل بازگشت نیستند.
						</div>
					</div>

					<div className="d-flex flex-wrap gap-2">
						<Button
						variant="outline-danger"
						size="sm"
						onClick={() =>
							openDebtDeleteConfirmation(
							"current"
							)
						}
						>
						حذف بدهی جاری
						</Button>

						<Button
						variant="outline-danger"
						size="sm"
						onClick={() =>
							openDebtDeleteConfirmation(
							"previous"
							)
						}
						>
						حذف بدهی سال قبل
						</Button>

						<Button
						variant="outline-danger"
						size="sm"
						onClick={() =>
							openDebtDeleteConfirmation(
							"monthly"
							)
						}
						>
						حذف کسر ماهانه
						</Button>
					</div>
					</div>
				</Card.Body>
			</Card>



			<div className="mb-3 d-flex flex-wrap gap-2 align-items-end">
				<Form.Control placeholder="کاربر (نام، موبایل، کد)" value={filter.user} onChange={(e) => { setFilter({ ...filter, user: e.target.value }); setPage(1); }} style={{ maxWidth: "150px" }} />
				<Form.Control placeholder="فروشگاه" value={filter.store} onChange={(e) => { setFilter({ ...filter, store: e.target.value }); setPage(1); }} style={{ maxWidth: "120px" }} />
				<Form.Select
          value={filter.type}
          onChange={(e) => { setFilter({ ...filter, type: e.target.value }); setPage(1); }}
          style={{ maxWidth: "110px" }}
        >
					<option value="">نوع تراکنش</option>
					<option value="charge">شارژ</option>
					<option value="withdraw">کسر</option>
					<option value="purchase">خرید</option>
				</Form.Select>
				<Form.Select value={filter.source} onChange={(e) => { setFilter({ ...filter, source: e.target.value }); setPage(1); }} style={{ maxWidth: "110px" }}>
					<option value="">حساب</option>
					<option value="wallet">کیف پول</option>
					<option value="credit">اعتبار</option>
				</Form.Select>
				<Form.Control placeholder="توسط (نام ایجادکننده)" value={filter.createdBy} onChange={(e) => { setFilter({ ...filter, createdBy: e.target.value }); setPage(1); }} style={{ maxWidth: "150px" }} />

				{/* <Form.Control
          type="date"
          value={filter.startDate}
          onChange={(e) => { setFilter({ ...filter, startDate: e.target.value }); setPage(1); }}
          style={{ maxWidth: "150px" }}
        />
        <Form.Control
          type="date"
          value={filter.endDate}
          onChange={(e) => { setFilter({ ...filter, endDate: e.target.value }); setPage(1); }}
          style={{ maxWidth: "150px" }}
        /> */}

				{/* تاریخ شمسی */}
				<div className="d-flex align-items-center gap-2">
					<DateTimePicker onChange={(d) => { setFilter({ ...filter, startDate: d }); setPage(1); }} value={filter.startDate} calendarIcon={null} clearIcon={null} locale="fa-IR" format="y/MM/dd" />
					<span>تا</span>
					<DateTimePicker onChange={(d) => { setFilter({ ...filter, endDate: d }); setPage(1); }} value={filter.endDate} calendarIcon={null} clearIcon={null} locale="fa-IR" format="y/MM/dd" />
				</div>

				{/* بازه‌های زمانی */}
				<div className="d-flex gap-1">
					<Button variant="outline-primary" size="sm" onClick={() => setRange("week")}>
						هفته جاری
					</Button>
					<Button variant="outline-primary" size="sm" onClick={() => setRange("month")}>
						ماه جاری
					</Button>
					<Button variant="outline-primary" size="sm" onClick={() => setRange("year")}>
						سال جاری
					</Button>
				</div>

				<Form.Control placeholder="جستجوی کلی" value={filter.search} onChange={(e) => { setFilter({ ...filter, search: e.target.value }); setPage(1); }} style={{ maxWidth: "150px" }} />

				{/* دکمه‌ها */}
				<Button variant="primary" onClick={fetchTransactions}>
					اعمال فیلتر
				</Button>
				{/* ریست */}
				<Button
					variant="secondary"
					title="ریست فیلترها"
					onClick={handleReset}>
					&times;
				</Button>
				
				<Button
					variant="success"
					onClick={exportExcel}
					disabled={downloading}
				>
					{downloading ? (
						<span>
						در حال ساخت فایل...
						<span className="spinner-border spinner-border-sm ms-2" />
						</span>
					) : (
						"خروجی اکسل"
					)}
				</Button>
			</div>

			{/* جدول */}
			<Table striped bordered hover responsive>
				<thead>
					<tr>
						<th>#</th>
						<th>شناسه</th>
						<th onClick={() => handleSort("user")} style={{ cursor: "pointer" }}>
							<div className="d-flex justify-content-between align-items-center">
								کاربر
								<SortIcon column="user" />
							</div>
            			</th>
						<th>گروه کاربر</th>
						<th onClick={() => handleSort("store")} style={{ cursor: "pointer" }}>
							<div className="d-flex justify-content-between align-items-center">
								فروشگاه
								<SortIcon column="store" />
							</div>
            			</th>
						<th onClick={() => handleSort("amount")} style={{ cursor: "pointer" }}>
							<div className="d-flex justify-content-between align-items-center">
								مبلغ
								<SortIcon column="amount" />
							</div>
           	 			</th>
						<th>دسته محصول</th>
						<th>نوع تراکنش</th>
						<th>حساب</th>
						<th>بالانس</th>
						<th>توسط</th>
						<th>وضعیت</th>
						<th onClick={() => handleSort("createdAt")} style={{ cursor: "pointer" }}>
							<div className="d-flex justify-content-between align-items-center">
								تاریخ
								<SortIcon column="createdAt" />
							</div>
						</th>
						<th>توضیحات</th>
						<th>عملیات</th>
					</tr>
				</thead>
				<tbody>
					{transactions.map((t, idx) => (
						<tr key={t.id}>
							<td>{(page - 1) * perPage + (idx + 1)}</td>
					    	<td>{(t.user?.code || '')}</td>
							<td>{`${t.user?.name || '-'} ${t.user?.family || '-'}`}</td>
							<td>{t.user?.category?.name || "-"}</td>
							<td>{t.store?.name || "-"}</td>
							<td>{Number(t.amount || 0).toLocaleString()}</td>
							<td>{t.category?.title || "-"}</td>
							<td>{t.type === "charge" ? "شارژ" : t.type === "withdraw" ? "کسر از موجودی" : t.type === "purchase" ? "خرید از فروشگاه" : "-"}</td>
							<td>{t.source === "wallet" ? "کیف پول" : t.source === "credit" ? "اعتبار" : "-"}</td>
							<td>{Number(t.balanceAfter || 0).toLocaleString() || ''}</td>
							<td>
								{`${t.createdBy?.name || "-"} ${t.createdBy?.family || "-"}
                				${t.createdBy?.role === "ADMIN" ? " (ادمین)" : t.createdBy?.role === "STORE" ? " (فروشگاه)" : t.createdBy?.role === "USER" ? " (کاربر)" : ""}`}
							</td>
							<td>{t.status}</td>
							<td style={{ direction: "ltr" }}>{formatJalali(t.createdAt)}</td>
							<td>{t.description || "-"}</td>
							<td>
								{t.type === "purchase" && (
									<Button
										size="sm"
										variant="outline-danger"
										onClick={() => setRefundPurchase(t)}
										title="برگشت سفارش"
									>
										<ArrowCounterclockwise className="me-1" />
									</Button>
								)}
							</td>
						</tr>
					))}
				</tbody>
			</Table>

      <PaginationBarComp
        page={page}
        setPage={setPage}
        totalPages={totalPages}
        perPage={perPage}
        setPerPage={setPerPage}
      />

      {/* <div className="d-flex justify-content-between align-items-center mt-3">
        <div>صفحه {page} از {totalPages}</div>
        <div className="d-flex gap-2">
          <Button
            variant="outline-secondary"
            size="sm"
            disabled={page <= 1}
            onClick={() => setPage(page - 1)}
          >
            قبلی
          </Button>
          <Button
            variant="outline-secondary"
            size="sm"
            disabled={page >= totalPages}
            onClick={() => setPage(page + 1)}
          >
            بعدی
          </Button>
        </div>
      </div> */}


		
			<Modal
				show={deleteDebtModal.show}
				onHide={() => {
					if (!deletingDebt) {
					setDeleteDebtModal({
						show: false,
						type: "",
						title: "",
						description: "",
					});
					}
				}}
				centered
				>
				<Modal.Header closeButton>
					<Modal.Title className="text-danger">
					تأیید حذف
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div className="mb-3">
					<strong>
						{deleteDebtModal.title}
					</strong>
					</div>

					<p className="mb-3">
					{deleteDebtModal.description}
					</p>

					<Alert variant="danger">
					⚠️ هشدار: این عملیات حذف فیزیکی است و
					اطلاعات حذف‌شده قابل بازیابی نیست.
					</Alert>

					<p className="mb-0">
					آیا مطمئن هستید که می‌خواهید ادامه دهید؟
					</p>
				</Modal.Body>

				<Modal.Footer>
					<Button
					variant="secondary"
					onClick={() =>
						setDeleteDebtModal({
						show: false,
						type: "",
						title: "",
						description: "",
						})
					}
					disabled={deletingDebt}
					>
					انصراف
					</Button>

					<Button
					variant="danger"
					onClick={confirmDeleteDebt}
					disabled={deletingDebt}
					>
					{deletingDebt ? (
						<>
						<Spinner
							animation="border"
							size="sm"
							className="me-2"
						/>
						در حال حذف...
						</>
					) : (
						"بله، حذف شود"
					)}
					</Button>
				</Modal.Footer>
			</Modal>

			<RefundModal
				show={!!refundPurchase}
				purchase={refundPurchase}
				role="ADMIN"
				onHide={() => setRefundPurchase(null)}
				onSuccess={fetchTransactions}
			/>
		</>
	);
};

export default AdminTransactionsComp;
